import { Text } from "@gravity-ui/uikit";
import { PriceDtoCurrencyEnum } from "definitions/product-storage";
import { formatPrice } from "src/util";

export interface PriceRange {
  minPrice: number;
  maxPrice: number;
  currency: PriceDtoCurrencyEnum;
}

export interface PriceCellProps {
  priceRange: PriceRange;
}

export const PriceCell = ({ priceRange }: PriceCellProps) => {
  return <Text variant="body-1">{formatPrice(priceRange)}</Text>;
};
